import React, { Component } from "react"
import styled from "styled-components"
import { appStrings } from "../../common/strings/app_strings"
import { SimpleSelect } from "react-selectize"
import { filterAvailableCalendars } from "../../util/google_calendar_config_utils"

const { selectPendingCalendar, selectCalendarDetail } = appStrings.connectedApps

const computeOptions = availableCalendars => {
    const calendarsToShow = filterAvailableCalendars(availableCalendars)
    const options = calendarsToShow.map(availableCalendar => {
        const { title, googleAccountEmail } = availableCalendar
        return {
            label: `${title} (${googleAccountEmail})`,
            value: title,
            calendar: availableCalendar,
        }
    })
    return options
}

export class SelectCalendarDropdownForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: null,
            options: [],
        }
    }
    select = calendar => {
        this.setState({ value: calendar })
        this.props.selectCalendar(calendar)
    }

    componentDidMount() {
        const options = computeOptions(this.props.availableCalendars)
        this.setState({ options })
    }

    componentDidUpdate(prevProps) {
        const { gCalendarSubscriptions, availableCalendars } = this.props
        if (
            gCalendarSubscriptions.length !=
                prevProps.gCalendarSubscriptions.length ||
            availableCalendars.length != prevProps.availableCalendars.length
        ) {
            const options = computeOptions(availableCalendars)
            this.setState({ options })
            setTimeout(() => {
                this.setState({
                    value: null,
                    options,
                })
            }, 500)
        }
    }
    render() {
        return (
            !!this.state.options.length && (
                <SimpleSelectWrapper className="settings-forms-container">
                    <div className="field-detail">{selectCalendarDetail}</div>
                    <SimpleSelect
                        id="simple-select-style"
                        options={this.state.options}
                        value={this.state.value}
                        onValueChange={calendar => {
                            return calendar ? this.select(calendar) : null
                        }}
                        theme="bootstrap3"
                        placeholder={selectPendingCalendar}
                    ></SimpleSelect>
                </SimpleSelectWrapper>
            )
        )
    }
}

const SimpleSelectWrapper = styled.div`
    padding-bottom: 5px;
    width: 64%;
    .field-detail {
        font-weight: 400;
        font-size: small;
        margin-top: 10px;
    }
    #simple-select-style {
        width: 500px !important;
    }
    .react-selectize.bootstrap3.root-node .react-selectize-control {
        border-color: #ccc !important;
        outline: none !important;
        box-shadow: none !important;
    }

    @media (max-width: 1000px) {
        width: 100% !important;
        #simple-select-style {
            width: 100% !important;
        }
    }
`



// WEBPACK FOOTER //
// ./src/common/components/select_calendar_dropdown.js